import { cloneDeep } from '@apollo/client/utilities';
import { CompanyEntity } from '../common/entity';
import { WithCustomFields } from '../custom_field/customField';
import { applyMixins } from '../../util/mixins';

export enum CompanyInviteState {
  pending = 'pending',
  accepted = 'accepted',
}

export enum CompanyRole {
  administrator = 'COMPANY_ADMINISTRATOR',
  employee = 'COMPANY_EMPLOYEE',
  // viewer = 'COMPANY_VIEWER', Only used on the backend for partner companies
}

export class CompanyRoleAssignment extends CompanyEntity {
  userId!: string;
  email!: string;
  role: CompanyRole = CompanyRole.employee;
  state!: CompanyInviteState;

  constructor(obj: any) {
    if (!obj.companyId) return;
    super(obj.companyId);
    Object.assign(this, cloneDeep(obj));
    this.customFields = WithCustomFields.toCustomFieldsMap(obj);
  }

  withRole(role: CompanyRole) {
    this.role = role;
    return cloneDeep(this);
  }
}

export interface CompanyRoleAssignment extends WithCustomFields {}
applyMixins(CompanyRoleAssignment, [CompanyRoleAssignment, WithCustomFields]);
